<template>
    <div v-if="show">
        <v-overlay v-if="useOverlay" class="mit-progress-overlay" :opacity=".80" :value="show" :absolute="!overlayFullscreen">
            <v-progress-circular v-if="!progressBar" indeterminate :size="progressSize">
                {{message}}
            </v-progress-circular>
            <p v-if="progressBar">{{message}}</p>
            <v-progress-linear v-if="progressBar" color="primary" indeterminate></v-progress-linear>
        </v-overlay>
        <div v-if="!useOverlay" class="mit-progress">
            <v-progress-circular v-if="!progressBar" indeterminate :size="progressSize">
                {{message}}
            </v-progress-circular>
            <p v-if="progressBar">{{message}}</p>
            <v-progress-linear v-if="progressBar" color="primary" indeterminate></v-progress-linear>
        </div>

    </div>
</template>

<script>

export default {
  name: 'BaseMitLoading',
  components: {},
  props: {
    useOverlay:{
        default: true,
        type: Boolean
    },
    overlayFullscreen:{
      default: true,
      type: Boolean
    },
    show:{
      default: false,
      type: Boolean
    },
    message: {
      default: 'Loading...',
      type: String
    },
    progressBar:{
      default: false,
      type: Boolean
    },
    progressSize:{
      default: 88,
      type: Number
    }
  },
  data: function() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
    .mit-progress-overlay {
      height:100vh;
    }
    .mit-progress {
      display: flex;
      align-items: center;
      justify-content: center;
    }
</style>
